module.exports = __webpack_public_path__ + "static/media/167-saint-kitts-and-nevis.3686ec02.svg";